import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import PasswordGate from './components/PasswordGate';
import PromptPage from './components/PromptPage';
import LoginPage from './pages/LoginPage';
import ChatPage from './pages/ChatPage';
import { useAuthStore } from './stores/useAuthStore';
import './App.css';

function App() {
  const loadCurrentUser = useAuthStore((s) => s.loadCurrentUser);

  useEffect(() => {
    loadCurrentUser();
  }, [loadCurrentUser]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/chat" element={<ChatPage />} />
        <Route path="/prompting" element={<PromptPage />} />
        <Route
          path="*"
          element={
            <PasswordGate>
              <div className="App">
                <Dashboard />
              </div>
            </PasswordGate>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
